export const scrollToElement = (
  selector: string,
  offsetCallback?: (el: any, top: number) => number
) => {
  const element = document.querySelector(selector);
  if (element) {
    // element.scrollIntoView({ behavior: "smooth", block: "start" });
    const elementTop = element.getBoundingClientRect().top + window.scrollY;
    const offset = offsetCallback ? offsetCallback(element, elementTop) : 0;

    window.scrollTo({
      top: elementTop + offset,
      behavior: 'smooth',
    });
  }
}